import { Button } from '@chakra-ui/react';

type TQuantityControlProps = {
  value: number;
  handleSetValue: (value: number) => void;
  max?: number;
};

export default function QuantityControl({
  value,
  handleSetValue,
  max = 0,
}: TQuantityControlProps) {
  return (
    <div className="flex gap-[6px] items-center">
      <Button
        size="sm"
        bg="white"
        border="1px solid #9CA3AF"
        rounded="full"
        p="0"
        onClick={() =>
          handleSetValue(max ? (value > max ? max : +value - 1) : value - 1)
        }
        isDisabled={value <= 1}
      >
        -
      </Button>
      <span className="font-bold mx-[6px]">{value}</span>
      <Button
        size="sm"
        bg="white"
        border="1px solid #9CA3AF"
        rounded="full"
        p="0"
        onClick={() =>
          handleSetValue(max ? (value >= max ? max : +value + 1) : value + 1)
        }
      >
        +
      </Button>
    </div>
  );
}
